"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _CreateReportFormComponent = _interopRequireDefault(require("./CreateReportFormComponent"));
var _modalActions = require("../../../redux/actions/modalActions");
var _reportsPayloadHelper = require("../../../helpers/reportsPayloadHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FORM = 'createReport';
var selector = (0, _reduxForm.formValueSelector)(FORM);
var mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user,
    accounts = _state$user.accounts,
    selectedAccountId = _state$user.selectedAccountId;
  var startDate = selector(state, 'startDate');
  var endDate = selector(state, 'endDate');
  var buttonDisabled = !startDate || startDate === '__/__/____' || !endDate || endDate === '__/__/____';
  return {
    accounts: accounts,
    startDate: startDate,
    buttonDisabled: buttonDisabled,
    selectedAccountId: selectedAccountId,
    initialValues: _defineProperty({
      type: 'TradeActivity'
    }, selectedAccountId, true)
  };
};
var CreateReportForm = (0, _reduxForm.reduxForm)({
  form: FORM,
  onSubmit: function onSubmit(values, dispatch, ownProps) {
    var payload = (0, _reportsPayloadHelper.getReportsPayload)(values, ownProps);
    return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_SINGLE_REPORT, {
      payload: payload
    }));
  }
})(_CreateReportFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(CreateReportForm);